module.exports = __webpack_public_path__ + "assets/img/gal_06.c4728a33.jpg";